import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";

export const receivingDashboardOrders = createPaginatedList({
  listId: "receivingDashboardOrders",
  fetch: api.orders.search,
  initialSettings: {
    filters: {
      virtual_receiving: false
    }
  }
});

export const virtualReceivingDashboardOrders = createPaginatedList({
  listId: "virtualReceivingDashboardOrders",
  fetch: api.orders.search,
  initialSettings: {
    filters: {
      virtual_receiving: true
    }
  }
});



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/pagination.js